import type { LOAN_REQUEST_COMMANDS } from 'cpool-constants';

type SubstatusCommand =
    | typeof LOAN_REQUEST_COMMANDS.changeStatus
    | typeof LOAN_REQUEST_COMMANDS.createNote
    | typeof LOAN_REQUEST_COMMANDS.setResubmission;

export class SubstatusCommandError extends Error {
    constructor(
        readonly command: SubstatusCommand,
        // set when setResubmission already succeeded before a later command failed
        readonly resubmissionPosition: number | null,
        readonly cause: unknown,
    ) {
        super(`${command} failed`);
        this.name = 'SubstatusCommandError';
    }
}
